import React from "react";
import RowHeading from "./RowHeading";

// These constants needed for column headings
const maxRankings = 6;
const OrderWords = [
  "First",
  "Second",
  "Third",
  "Fourth",
  "Fifth",
  "Sixth",
  "Seventh",
  "Eighth",
  "Nineth"
];
const OrderNumbers = [
  "1st",
  "2nd",
  "3rd",
  "4th",
  "5th",
  "6th",
  "7th",
  "8th",
  "9th"
];

// Represents a single ranking of a single candidate
const Choice = ({ divKey, filled, onClick }) => (
  <div
    key={divKey}
    className={`oval ${filled ? "filled" : ""}`}
    onClick={onClick}
  />
);

// Represents the set of possible rankings for a single candidate
const Choices = ({ rowIndex, choiceCount, onClick, ranking, errors }) =>
  Array(choiceCount)
    .fill(0)
    .map((elem, n) => (
      <td
        className={`${errors[ranking - 1] && n + 1 === ranking ? "error" : ""}`}
      >
        <Choice
          key={`rcvChoice${rowIndex}-${n}`}
          divKey={`rcvDiv${rowIndex}-${n}`}
          onClick={() => onClick(n + 1)}
          filled={n + 1 === ranking}
        />
      </td>
    ));

// Represents the row of all data for a single candidate
const Row = ({
  rowIndex,
  candidate,
  bioUrl,
  party,
  choiceCount,
  ranking,
  errors,
  onClick
}) => (
  <tr key={`rcvRow${rowIndex}`}>
    <RowHeading candidate={candidate} bioUrl={bioUrl} party={party} />
    <Choices
      key={`rcvChoices${rowIndex}`}
      rowIndex={rowIndex}
      choiceCount={choiceCount}
      ranking={ranking}
      errors={errors}
      onClick={onClick}
    />
  </tr>
);

// Represents the list of rows corresponding to the list of candidates
const Rows = ({ choiceCount, candidates, rankings, errors, onClick }) =>
  candidates.map((row, n) => (
    <Row
      rowIndex={n}
      key={`rcvRow${n}`}
      candidate={row.candidate}
      bioUrl={row.bioUrl}
      party={row.party}
      choiceCount={choiceCount}
      ranking={rankings[n]}
      errors={errors}
      onClick={ranking => onClick(n, ranking)}
    />
  ));

// Represents the column heading for one of the possible rankings
const ColumnHeading = ({ number, word, error }) => (
  <th className={`columnHeading ${error ? "error" : ""}`}>
    <p className="rotate">
      {word}
      <br />
      Choice
    </p>
    <div>{number}</div>
  </th>
);

// Represents the list of column headings for all possible rankings
const ColumnHeadings = ({ choiceCount, errors }) =>
  Array(choiceCount)
    .fill(0)
    .map((e, i) => (
      <ColumnHeading
        key={`rcvColumn${i}`}
        number={OrderNumbers[i]}
        word={OrderWords[i]}
        error={errors[i]}
      />
    ));

// Renders a complete RCV ballot for a single race
export default function RcvBallotView({
  race,
  candidates,
  rankings,
  errors,
  onClick,
  readonly
}) {
  const candidateCount = candidates.length;
  const choiceCount =
    candidateCount > maxRankings ? maxRankings : candidateCount;
  return (
    <div className={`ballot rcv ${readonly ? "noHover" : ""}`}>
      <table>
        <thead>
          <tr>
            <td colSpan={choiceCount + 1} className="title">
              {race}
            </td>
          </tr>
          <tr>
            <th className="instructions rcv">
              <p>Rank up to {choiceCount} candidates.</p>
              <p className={errors.some(e => e) ? "error" : ""}>
                Mark no more than 1 oval in each column.
              </p>
            </th>
            <ColumnHeadings choiceCount={choiceCount} errors={errors} />
          </tr>
        </thead>
        <tbody>
          <Rows
            choiceCount={choiceCount}
            candidates={candidates}
            rankings={rankings}
            errors={errors}
            onClick={onClick}
          />
        </tbody>
      </table>
    </div>
  );
}
